// extracted by mini-css-extract-plugin
export default {"content":"successList_content__+pD70","collapsed":"successList_collapsed__0JPzc"};